import { makeStyles } from "tss-react/mui";
import { MiBadge } from "@miplatform/components";

export const MiAttemptNumberBadge = ({ attemptNumber, className = null }: { attemptNumber: string; className?: string | null }) => {
  const { classes, theme } = useStyles();

  return (
    <MiBadge
      className={`${classes.badge} ${className || ""}`}
      data-testid="attempt-number"
      text={`Attempt #${attemptNumber}`}
      fontSize={theme.fontSize.xsmall}
      backgroundColor={theme.palette.orange.main}
      borderColor={theme.palette.orange.dark}
      color={theme.palette.common.white}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  badge: {
    display: "flex",
    alignItems: "center",
    height: theme.spacing(4.5),
    borderRadius: theme.spacing(0.5),
    whiteSpace: "nowrap",
  },
}));
